import { slideDown, slideUp } from '@common/slide'
import { isTouchDevice } from '@common/util'
import hoverIntent from '@common/hover-intent'
import scrollReveal from '@scripts/components/scroll-reveal'
import { setupSliders } from '@elements/content-media'
import { on } from 'delegated-events'

let touchPos

const activateMemberSlide = (el) => {
  el.classList.add('is-active')

  const fullDetails = el.querySelector('.team-member-full-details')

  if (fullDetails.classList.contains('has-full-details')) {
    slideDown(fullDetails, 200)
  }
}

const deactivateMemberSlide = async (el) => {
  const fullDetails = el.querySelector('.team-member-full-details')

  if (fullDetails.classList.contains('has-full-details')) {
    await slideUp(fullDetails, 200)
  }

  el.classList.remove('is-active')
}

const activateMemberOverlay = (el) => {
  el.classList.add('is-active')
}

const deactivateMemberOverlay = (el) => {
  el.classList.remove('is-active')
}

const setupMembers = async () => {
  const holder = document.querySelector('.team-members-holder')
  const asSlide = holder.classList.contains('as-slide')
  const members = document.querySelectorAll('.team-member')

  const teamPhoto = document.querySelector('[data-page-team-photo]')
  if (teamPhoto) {
    const filtered = document.querySelector('[data-page-filters]')

    if (filtered.classList.contains('is-filtered')) {
      teamPhoto.classList.add('hidden')
    }
  }

  if (members.length) {
    if (!isTouchDevice) {
      new hoverIntent(members, {
        onEnter: asSlide ? activateMemberSlide : activateMemberOverlay,
        onExit: asSlide ? deactivateMemberSlide : deactivateMemberOverlay,
        exitDelay: 100,
        interval: 100,
        sensitivity: 7,
      })
    }

    const quoteSliders = document.querySelectorAll('.team-member-quote-slider')

    if (quoteSliders.length) {
      import('swiper/css')
      import('swiper/css/autoplay')
      import('swiper/css/effect-fade')
      const { default: Swiper, Autoplay, EffectFade } = await import('swiper')

      Swiper.use([Autoplay, EffectFade])

      quoteSliders.forEach((el) => {
        const container = el.querySelector('.swiper')
        const numSlides = el.querySelectorAll('.swiper-slide').length

        if (numSlides > 1) {
          new Swiper(container, {
            slidesPerView: 1,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
              crossFade: true,
            },
            loop: true,
            loopedSlides: numSlides,
            autoplay: {
              delay: 4000,
              disableOnInteraction: false,
            },
          })
        }
      })
    }
  }
}

const init = () => {
  setupMembers()

  on('pagecontent:replace', 'html', () => {
    setupMembers()
    setupSliders()

    scrollReveal.init()
  })

  if (isTouchDevice) {
    on('touchstart', '.team-member', () => (touchPos = window.scrollY))

    on('touchend', '.as-slide .team-member', (e) => {
      const touchDiff = Math.abs(window.scrollY - touchPos)

      if (touchDiff < 10) {
        const el = e.target.closest('.team-member')

        if (el && !e.target.closest('a')) {
          if (el.classList.contains('is-active')) {
            deactivateMemberSlide(el)
          } else {
            activateMemberSlide(el)
          }
        }
      }
    })

    on('touchend', '.as-overlay .team-member', (e) => {
      const touchDiff = Math.abs(window.scrollY - touchPos)

      if (touchDiff < 10) {
        const el = e.target.closest('.team-member')

        if (el && !e.target.closest('a')) {
          if (el.classList.contains('is-active')) {
            deactivateMemberOverlay(el)
          } else {
            activateMemberOverlay(el)
          }
        }
      }
    })
  }
}

init()
